exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".consultant-grid-vueapp{width:100%}.consultant-grid-wrapper{max-width:991px;margin:0 auto;position:relative;overflow:hidden}.consultant-item-container{max-width:1236px;margin:0 auto;position:relative;overflow:hidden}.c2c-call .dropdown-toggle{height:40px!important;text-align:center}.no-cosnultant{font-size:32px;text-align:center;background-color:#f9080887;color:#ffff}@media (max-width:668px){.consultant-info-container,.consultant-left-container{width:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c4e27750","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 30
// module chunks = 0